import { ODOMETRY_PATH_OBJECT_NAME } from "@/components/r3f/renderers/odometry-paths/odometry-path-renderer";
import { CadModelObject } from "@/object-cache";
import { OverviewPlaceholders } from "@faro-lotv/lotv";
import { Mesh, Object3D } from "three";

/**
 * Tagging enum type to determine which subobject of a 3js scene is dispatched
 * to which rendering step.
 */
export enum RenderDispatch {
  LodPointCloud = 0,
  CadModel = 1,
  Dollhouse = 2,
  Floorplan = 3,
  Placeholders = 4,
  OdometryPath = 5,
  Lines = 6,
  Other = 7,
  Pivot = 8,
  BoxControls = 9,
  GridPlane = 10,
  PreviewPlane = 11,
  GaussianSplats = 12,
  /** Explicitly defining None type when an object should not be dispatched to any rendering pass. */
  None = 13,
}

/**
 *
 * @param obj The root of a 3js scene subtree
 * @param flag The flag to assign to the userData.type field of all objects in the subtree
 */
export function flagSubtree(obj: Object3D, flag: RenderDispatch): void {
  obj.traverse((o) => (o.userData.type = flag));
}

// TODO: Pull these functions into different file or to the corresponding objects
// They should then be used consistently in all scenes
// See https://faro01.atlassian.net/browse/SWEB-1771

/**
 * @param obj The 3D object to check for being a measurement line.
 * @returns true, if the given 3D object is a measurement line.
 */
export function isObjLine(obj: Object3D): obj is Mesh {
  return obj instanceof Mesh && obj.material.type === "LineMaterial";
}

/**
 * @param obj The object to check for being the placeholders.
 * @returns whether this object 3D is an instance of the overview placeholders.
 */
export function isObjPlaceholders(obj: Object3D): obj is OverviewPlaceholders {
  return obj instanceof OverviewPlaceholders;
}

/**
 * @param obj The object to check for being an odometry path.
 * @returns whether this object 3D is an odometry path.
 */
export function isObjOdometryPath(obj: Object3D): boolean {
  return obj.name === ODOMETRY_PATH_OBJECT_NAME;
}

/**
 * Set correct dispatch type for the CAD model object.
 *
 * @param cadModel The cad model object to set the dispatch type for
 */
export function setCadModelRenderDispatch(cadModel: CadModelObject): void {
  flagSubtree(cadModel, RenderDispatch.CadModel);
}
